import BaseLegend from "../../sisu/chart/BaseLegend.sisu";

const NeoLegend = BaseLegend

export default NeoLegend